module.exports = __webpack_public_path__ + "img/plan-1.74705c90.png";